import { ImageUtils } from "@homeleite/common-utils";

export class MilkControlStatus {
    public static PREVIOUS = new MilkControlStatus("Controle Anterior", ImageUtils.DEFAULT_MILK_ICON);
    public static CURRENT = new MilkControlStatus("Controle Atual", ImageUtils.DEFAULT_BOTTLE_ICON);

    public constructor(
        public readonly description: string,
        public readonly icon: string
    ) { }

    public static values(): MilkControlStatus[] {
        return [
            MilkControlStatus.PREVIOUS,
            MilkControlStatus.CURRENT
        ];
    }
}
